import type {
  Filter,
  FilterOption,
  FilterCategory,
} from '@interfaces/filters/catalog';
import type { FilterKind } from '@interfaces/filters/domain';

export interface BootstrapFilterOption {
  id: number;
  code: string;
  name: string;
  displayLabel: string;
  displaySequence: number;
  markets: number[];
}

export interface BootstrapFilterCategoryEmbed {
  id: number;
  name: string;
  displayLabel: string;
}

export interface BootstrapFilter {
  id: number;
  code: string;
  name: string;
  displayLabel: string;
  origin: 'STANDARD' | 'CUSTOM';
  component: 'OPTION' | 'RANGE' | string; // string accepted, mapped defensively
  category: BootstrapFilterCategoryEmbed | null;
  markets: number[];
  options: BootstrapFilterOption[];
}

export function normaliseBootstrapFilters(input: BootstrapFilter[]): {
  filters: Filter[];
  categories: FilterCategory[];
} {
  const categoriesMap = new Map<number, FilterCategory>();
  const filters: Filter[] = [];

  for (const bf of input) {
    if (bf.category && !categoriesMap.has(bf.category.id)) {
      categoriesMap.set(bf.category.id, {
        id: bf.category.id,
        name: bf.category.name,
        displayLabel: bf.category.displayLabel ?? bf.category.name ?? '',
      });
    }
    const kind: FilterKind = bf.component === 'RANGE' ? 'RANGE' : 'OPTION';
    const options: FilterOption[] = bf.options.map((o) => ({
      id: o.id,
      code: o.code,
      name: o.name,
      displayLabel: o.displayLabel ?? o.name ?? '',
      displaySequence: o.displaySequence,
      markets: o.markets,
    }));
    filters.push({
      id: bf.id,
      code: bf.code,
      name: bf.name,
      displayLabel: bf.displayLabel ?? bf.name ?? '',
      kind,
      origin: bf.origin,
      categoryId: bf.category?.id ?? null,
      markets: bf.markets,
      options,
    });
  }

  return { filters, categories: [...categoriesMap.values()] };
}
